import React from "react";
import ObGynSidebar from "../Utils/ObGynSidebar";
import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import ObGynPatientInfo from "../Utils/ObGynPatientInfo";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import {connect} from "react-redux";
import {VisitHistory} from "../Utils/VisitHistory";

const ViewGynTreatmentDetails = ({actions, snackbars, match}) => {
    const {patient_number, visit_id, patient_type} = match.params;

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };

    const {openBar, type, message} = snackbars;



    // get the doctor's name
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;



    return (
        <div className='journals'>
            <PageTitle title="Treatment Details"/>
            <SubHeader
                title="Doctor"
                subTitle="Treatment Details"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <div style={{padding: '12px 16px'}}>
                    {/*<PatientInformation {...{patient_number,visit_id}}/>*/}
                    <VisitHistory {...{actions,  visit:{visit_id, patient_number}}}/>
                </div>
            </ObGynSidebar>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        snackbars: state.snackbar
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewGynTreatmentDetails);